import { render, staticRenderFns } from "./TrainingConfigurationPopup.vue?vue&type=template&id=56cf6ce8&scoped=true&"
import script from "./TrainingConfigurationPopup.vue?vue&type=script&lang=js&"
export * from "./TrainingConfigurationPopup.vue?vue&type=script&lang=js&"
import style0 from "./TrainingConfigurationPopup.vue?vue&type=style&index=0&id=56cf6ce8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf6ce8",
  null
  
)

export default component.exports